<template>
  <section class="funUser">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="450px"
      @close="cancelSubmit"
    >
      <div class="funUser-content">
        负责人：
        <el-select v-model="userId" clearable placeholder="请选择">
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div slot="footer" class="funUser-foot">
        <el-button @click="cancelSubmit">
          取 消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'ComFunUser',
  components: {},
  props: {
    value: Boolean,
    id: Number,
    id1: Number,
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      userId: ''
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.userId = this.id1 ? this.id1 : ''
        }
      }
    }
  },
  mounted() {},
  methods: {
    init(v) {},
    handleSubmit() {
      this.$emit('lock', this.id, this.userId)
      this.dialogVisible = false
    },
    cancelSubmit: function() {
      this.dialogVisible = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped >
.funUser {
  &-content {
    height: 100%;
    text-align: center;
    padding: 10px 0;
  }
}
</style>

